// NY tax 0.1.0-rc4 sends this exact text as the updateOrder.totals error when
// Stripe Tax cannot place the shipping address (customer_tax_location_invalid):
// HooligansTaxPolicy::MESSAGE_ADDRESS, shared/opencart-tools/ny-tax/README.md.
// Any other failure keeps the checkout's own fixed texts.
export const TAX_ADDRESS_MESSAGE =
  "We couldn't verify this shipping address for sales tax. Please check the ZIP code and state.";

const graphQLErrors = (error) => [
  ...(Array.isArray(error?.graphQLErrors) ? error.graphQLErrors : []),
  ...(Array.isArray(error?.networkError?.result?.errors)
    ? error.networkError.result.errors
    : []),
];

// The address text when this updateOrder failure is that one, else null.
export function taxAddressError(error) {
  return graphQLErrors(error).some(
    (entry) =>
      entry?.message === TAX_ADDRESS_MESSAGE &&
      (!Array.isArray(entry.path) || entry.path[0] === "updateOrder")
  )
    ? TAX_ADDRESS_MESSAGE
    : null;
}

// The delivery fields Stripe Tax locates; editing any of them retires the text.
const LOCATION_FIELDS = [
  "address1",
  "address2",
  "city",
  "postcode",
  "zone_id",
  "country_id",
];

export function deliveryLocationSignature(fields = []) {
  const byName = new Map(
    (Array.isArray(fields) ? fields : []).map((field) => [
      field?.name,
      field?.value,
    ])
  );
  return LOCATION_FIELDS.map((name) => String(byName.get(name) ?? "")).join(
    "\u0000"
  );
}
